__webpack_require__.p = "/bridge/_next/";